angular
  .module("luoghiInstallazionePv.components", [])
  .component("luoghiInstallazionePv", {
    templateUrl:
      "ng/components/luoghiInstallazionePv/luoghiInstallazionePv.html",
    bindings: {
      model: "<",
      exportValidity: "&",
      readOnly: "=",
      loaderObj: "<",
      cedente: "<"
    },
    controllerAs: "luoghiInstallazionePvCtrl",
    controller: function LuoghiInstallazionePv(
      $financialApiService,
      $RichiestePostVenditaService,
      $modalService,
      $timeout,
      Sede,
      $configService
    ) {
      var self = this;

      self.$onInit = function () {
        if (
          self.model.contratti &&
          self.model.contratti[0] &&
          !self.model.contratti[0].dettaglioBeni
        ) {
          self.model.contratti[0].dettaglioBeni = [];
        }
        var selectedAll =
          self.model.contratti &&
          self.model.contratti[0] &&
          self.model.contratti[0].dettaglioBeni &&
          self.model.contratti[0].dettaglioBeni.every((x) => {
            return x.selected == true;
          });
        self.supportModel = {
          dettaglioList: self.model.contratti[0].dettaglioBeni,
          enableModal: false,
          selectDeselectAll: {
            selected: selectedAll,
          },
          sedeConsegnaSelected: Sede.build(),
          newSedeConsegna: Sede.build(),
          addressList: [],
          clienteProprietarioImm: true,
          enableConfButton: false,
        };

        if (!self.supportModel.dettaglioList.length) {
          getElencoBeniFromList();
        } else {
          populateAddresses()
        }
        selectAddress();
        verifyDatiCessionario()
      };

      var getElencoBeniFromList = function () {
        self.gettingElencoBeni = true;
        var appContractList = [
          {
            numeroContratto: self.model.contratti[0].numero,
            modulo: self.model.contratti[0].modulo,
            prodotto: self.model.contratti[0].codProdotto,
            ndgCliente: self.cedente
          },
        ];
        self.supportModel.dettaglioList = [];
        $RichiestePostVenditaService
          .getElencoBeniFromList(appContractList)
          .then(function (response) {
            if (response.success) {
              Object.keys(response.mapBeni).forEach(function (element) {
                self.model.contratti.forEach(function (contratto) {
                  if (contratto.numero + contratto.modulo === element) {
                    self.supportModel.dettaglioList = response.mapBeni[element];
                    response.mapBeni[element].forEach(function (x) {
                      x.selected = true;
                    });
                  }
                });
              });
              populateAddresses()
              self.gettingElencoBeni = false;
            } else {
              self.gettingElencoBeni = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            self.gettingElencoBeni = false;
          });
      };

      self.handleChange = function (property, value) {
        switch (property) {
          case "noVariazioneInd":
            self.model.noVariazioneInd = value;
            if(value) {
              self.model.contratti[0].dettaglioBeni.forEach(function(x) {
                x.newIndirizzo = Sede.build();
                x.ragSocNominativo = null;
                x.cfPiva = null;
                x.clienteProprietarioImm = true;
                x.isNewAddress = false;
              })
            }
            break;
          case "sedeConsegna":
            self.supportModel.newSedeConsegna = value;
            break;
          case "clienteProprietarioImm":
            if(value) {
              self.supportModel.dettaglioList.forEach (function(x) {
                if(x.selected) {
                  x.ragSocNominativo = null;
                  x.cfPiva = null;
                }
              })
            }
            break;
        }
        verifyDatiCessionario();
      };

      self.onCheckboxChange = function (el) {
        el.selected = !el.selected;
        var allSelected = self.supportModel.dettaglioList.every(function (x) {
          return x.selected;
        });
        self.supportModel.selectDeselectAll.selected = allSelected
          ? true
          : false;
      };

      self.selectedDeselectedAll = function (element) {
        element.selected = !element.selected;
        self.supportModel.dettaglioList.forEach(function (dettaglio) {
          dettaglio.selected = element.selected;
        });
      };

      self.checkForShowMessage = function () {
        if (self.supportModel && self.supportModel.dettaglioList) {
          var oneElementSelected = self.supportModel.dettaglioList.some((x) => {
            return x.selected == true;
          });
        }
        return oneElementSelected;
      };

      self.modifyAddress = function () {
        self.openingModal = true;
        if(checkEqualAddresses()) {
          self.supportModel.dettaglioList.forEach(function(dettaglio) {
            if (dettaglio.selected && dettaglio.isNewAddress ){
              self.supportModel.newSedeConsegna = dettaglio.newIndirizzo;
              self.supportModel.ragSocNominativo = dettaglio.ragSocNominativo;
              self.supportModel.cfPiva = dettaglio.cfPiva;
              self.supportModel.clienteProprietarioImm = dettaglio.clienteProprietarioImm;
            } else if (dettaglio.selected && !dettaglio.isNewAddress) {
              self.supportModel.newSedeConsegna = Sede.build();
              self.supportModel.ragSocNominativo = null;
              self.supportModel.cfPiva = null;
              self.supportModel.clienteProprietarioImm = true;
            }
          })
        } else {
          self.supportModel.sedeConsegnaSelected.typeStreet = 'NUOVO INDIRIZZO';
          self.supportModel.newSedeConsegna = null;
          self.supportModel.ragSocNominativo = null;
          self.supportModel.cfPiva = null;
          self.supportModel.clienteProprietarioImm = true;
        }
        self.supportModel.enableModal = true;
        $timeout(function () {
          $modalService.openModal("luoghiInstallazioneModal");
          verifyDatiCessionario()
          self.openingModal = false;
        }, 500);
      };

      var checkEqualAddresses = function () {
        var selectedObjs = [];
        self.supportModel.dettaglioList.forEach(function (dettaglio) {
          if (dettaglio.selected) {
            selectedObjs.push(dettaglio);
          }
        });
        if (selectedObjs.length > 1) {
          const firstAddress = selectedObjs[0].newIndirizzo;
          return selectedObjs.every((item) => {
            const address = item.newIndirizzo;
            return (
              address.indirizzo == firstAddress.indirizzo &&
              address.provincia == firstAddress.provincia &&
              address.cap == firstAddress.cap &&
              address.numeroCivico == firstAddress.numeroCivico
            );
          });
        } else if (selectedObjs.length == 1) {
          return true;
        }
      };

      var selectAddress = function () {
        var identifier = $configService.getAppConfig().user.ndg;
        if (!identifier) {
          self.supportModel.addressList.push(
            Sede.build({ typeStreet: "NUOVO INDIRIZZO" })
          );
          self.supportModel.addressList.push(
            self.model.destinatario.sedeConsegna
          );
          return;
        }
        $financialApiService
          .searchAddress(identifier)
          .then(function (addressResponse) {
            addressResponse.nsilAddresses.forEach(function(address){
              self.supportModel.addressList.push(
                Sede.build(address)
              );
            })
            self.supportModel.addressList.forEach(function(address){
              address.luogoEsteso.nome = address.comune;
            })
            self.supportModel.addressList.push(
              Sede.build({ typeStreet: "NUOVO INDIRIZZO" })
            );
            self.supportModel.addressList.push(
              self.model.destinatario.sedeConsegna
            );
          })
          .catch(function (error) {
            console.log(error);
          });
      };

      self.closeModal = function () {
        $modalService.closeModal("luoghiInstallazioneModal");
        self.supportModel.enableModal = false;
        self.supportModel.sedeConsegnaSelected = Sede.build();
      };

      self.exportValiditySede = function (validity) {
        self.validitySede = validity;
      };

      self.verifyDatiModal = function () {
        if (
          self.supportModel.clienteProprietarioImm &&
          self.supportModel.sedeConsegnaSelected.typeStreet ===
          "NUOVO INDIRIZZO"
        ) {
          self.supportModel.enableConfButton = self.validitySede;
        } else if (
          self.supportModel.clienteProprietarioImm &&
          self.supportModel.newSedeConsegna.indirizzo
        ) {
          self.supportModel.enableConfButton = true;
        } else if (
          !self.supportModel.clienteProprietarioImm &&
          self.supportModel.newSedeConsegna.indirizzo &&
          self.supportModel.cfPiva &&
          self.supportModel.ragSocNominativo
        ) {
          self.supportModel.enableConfButton = true;
        } else {
          self.supportModel.enableConfButton = false;
        }
        return self.supportModel.enableConfButton;
      };

      var verifyDatiCessionario = function () {
        var dettaglioImmo = false;
        if (self.model.noVariazioneInd) {
          dettaglioImmo = true;
        } else {
          dettaglioImmo = self.supportModel.dettaglioList.some(function (
            dettaglio
          ) {
            return (
              dettaglio.newIndirizzo && dettaglio.newIndirizzo.indirizzo != null
            );
          });
        }
        if (dettaglioImmo) {
          self.exportValidity({
            validity: true,
          });
        } else {
          self.exportValidity({
            validity: false,
          });
        }
      };

      self.saveAddressInfo = function () {
        self.savingAddress = true;

        self.supportModel.dettaglioList.forEach(function (dettaglio) {
          if (dettaglio.selected) {
            dettaglio.newIndirizzo = self.supportModel.newSedeConsegna;
            dettaglio.cfPiva = self.supportModel.cfPiva;
            dettaglio.ragSocNominativo = self.supportModel.ragSocNominativo;
            dettaglio.clienteProprietarioImm =
              self.supportModel.clienteProprietarioImm;
            dettaglio.isNewAddress = true;
          }
          self.model.contratti[0].dettaglioBeni =
            self.supportModel.dettaglioList;
        });
        $timeout(function () {
          self.supportModel.newSedeConsegna = Sede.build();
          self.supportModel.sedeConsegnaSelected = Sede.build();
          self.supportModel.ragSocNominativo = null;
          self.supportModel.clienteProprietarioImm = true;
          self.supportModel.cfPiva = null;
          verifyDatiCessionario()
          self.closeModal();
          self.savingAddress = false;
        }, 500);
      };

      var populateAddresses = function() {
        self.supportModel.dettaglioList.forEach(function (dettaglio) {
          if (!dettaglio.newIndirizzo) {
            dettaglio.newIndirizzo = Sede.build();
          }
        });
      }
    },
  });
